const types = {
    CHOICE: "choice",
    SELECT: "select",
    RANDOM: "random"
}

export default types;


// WEBPACK FOOTER //
// ./src/Components/Panels/SharedComponents/Product/grouping.js